var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 62.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.66,61.34v-18c6.67,0,7-.29,7-5.55V25.18H0V9.3C17.38,7.8,19.73,6.58,22.73,0h4.7V37.76c0,5.26.19,5.55,7,5.55v18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.91,30.44H73.46c-2.44,3.38-7.51,5.35-17,5.35-12.4,0-18-5.17-18-16.06,0-9.77,7.14-18.51,28.19-18.51,22.07,0,29.3,10,29.3,30.44,0,16-4.41,30.62-20.29,30.62-7.42,0-13.52-3.19-14.65-18.5H57.68V61.34H39.83V40H64.26c.56,2.91,2.72,3.76,5.45,3.76,4.69,0,6.29-2.35,6.29-10.06C76,32.69,76,31.66,75.91,30.44Zm-9.3-14.56c-5.55,0-7.9,2.72-7.9,6.38,0,5.36,2.92,7.42,7.43,7.42s8.07-2.34,8.07-8C74.21,18.41,72,15.88,66.61,15.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.61,41.43l-11.37.09V36l15.41.28c4.6-4.32,11.46-6.76,21.14-8.27V24.24H100.61V2.16h52V27.9C145.7,29,141.76,31.75,139.5,36l9.21-.19v5.73l-11.09-.09c-1.12,5.35-.93,12.12-.65,19.91H110.76C110.76,52.79,112,46.31,114.61,41.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.1,62.66c-20.76,0-28.84-10.24-28.84-31.66S165.34.84,186.1.84,215,10.05,215,31,206.86,62.66,186.1,62.66Zm0-43.87c-6.3,0-9.21,3.47-9.21,12.12s2.91,13.24,9.21,13.24,9.39-4.7,9.39-13.24S192.3,18.79,186.1,18.79Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.2f1b4d9718b26e3503c9603c5fa78aba.svg";
export { ForwardRef as ReactComponent };